import { Skeleton } from "../ui/skeleton";

export const RecordLoader = () => {
  return (
    <div className="flex flex-col p-1 pt-2 gap-1" data-testid="loader">
      <Skeleton className="h-[2.2rem] w-full bg-gray-100" />
      <Skeleton className="h-[8.5rem] w-full bg-gray-100" />

      <div className="flex gap-1">
        <Skeleton className="h-[20rem] w-full bg-gray-100" />
        <Skeleton className="h-[20rem] w-full bg-gray-100" />
      </div>

      <div className="flex gap-1">
        <Skeleton className="h-[20rem] w-full bg-gray-100" />
      </div>
      <div className="flex gap-1">
        <Skeleton className="h-[20rem] w-full bg-gray-100" />
        <Skeleton className="h-[20rem] w-full bg-gray-100" />
      </div>
    </div>
  );
};
